export default "__VITE_ASSET__DejcymKv__"